/**
 * The office extensions a DocsAPI engine (OnlyOffice / EuroOffice) edits, and the
 * `documentType` each opens as — ONE list, for the editor registry (onlyoffice-registration)
 * and every surface that mounts the editor outside it (the share view).
 */
export type DocsApiDocumentType = 'word' | 'cell' | 'slide'

export const DOCSAPI_EXTENSIONS: Record<DocsApiDocumentType, readonly string[]> = {
  cell: ['xlsx', 'xls', 'ods', 'fods', 'ots'],
  word: ['docx', 'doc', 'odt', 'fodt', 'ott', 'rtf'],
  slide: ['pptx', 'ppt', 'odp', 'fodp', 'otp'],
}

/** The document type a DocsAPI editor opens `ext` as, or null when it is not an office file. */
export function docsApiDocumentType(ext: string): DocsApiDocumentType | null {
  const e = ext.toLowerCase()
  for (const t of Object.keys(DOCSAPI_EXTENSIONS) as DocsApiDocumentType[]) {
    if (DOCSAPI_EXTENSIONS[t].includes(e)) return t
  }
  return null
}
